module.exports = __webpack_public_path__ + "media/images/logos/windeurope-eolis2022-e2199604dc90ac6f46ad3c2e599431b0.svg";